// src/components/modals/ChangePasswordModal.jsx
import React, { useState } from "react";
import "./Modal.css";

export default function ChangePasswordModal({ show, username, onClose, onSubmit }) {
  const [pwd, setPwd] = useState("");
  if (!show) return null;
  return (
    <div className="modal-backdrop-custom">
      <div className="modal-custom">
        <button className="btn-close" onClick={onClose}>×</button>
        <h5>Nova senha para {username}</h5>
        <input
          type="password"
          className="form-control mb-3"
          placeholder="Nova senha"
          value={pwd}
          onChange={e => setPwd(e.target.value)}
        />
        <button className="btn btn-primary w-100" onClick={()=>onSubmit(username, pwd)}>
          Alterar Senha
        </button>
      </div>
    </div>
  );
}
